module.exports = __webpack_public_path__ + "assets/img/mailbox.1cb646bc.svg";